import React, { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { PlaidPostRedirectLoadingPage } from './PlaidPostRedirectLoadingPage'
import Loader from '../../../../components/Loader'

import { useQuery, useTracking } from 'utils'

export const OpenBankingAuthentication: FC = () => {
  const navigate = useNavigate()
  const query = useQuery()

  const [oauthStateId, setOauthStateId] = useState('')
  const [paymentPlan, setPaymentPlan] = useState('')
  const [quoteId, setQuoteId] = useState('')
  const [updateMode, setUpdateMode] = useState(false)

  const [isLoading, setIsLoading] = useState(true)

  const [timerStarted, setTimerStarted] = useState(false)
  const [isTimedOut, setIsTimedOut] = useState(false)

  useEffect(() => {
    if (timerStarted) {
      return
    }

    setTimerStarted(true)

    // If Plaid takes an unreasonable long time to send an event,
    // or if the user manually navigates to this page,
    // just error out to prevent user from being stuck in a loading screen
    setTimeout(() => {
      setIsTimedOut(true)
    }, 60 * 1000)
  }, [timerStarted])

  useEffect(() => {
    const quoteId = query.get('quoteId')
    const oauthStateId = query.get('oauth_state_id')
    const paymentPlan = query.get('payment')
    const updateMode = query.get('updateMode')

    if (quoteId && oauthStateId && paymentPlan && updateMode) {
      setOauthStateId(oauthStateId)
      setPaymentPlan(paymentPlan)
      setQuoteId(quoteId)
      setUpdateMode(updateMode === 'true')
      setIsLoading(false)
    }
  }, [query, setIsLoading, isTimedOut])

  useEffect(() => {
    if (isTimedOut && quoteId && paymentPlan) {
      navigate(
        `/quote/${quoteId}/connect-your-bank/error?payment=${paymentPlan}&errorCode=plaid_post_redirect_event_timeout`,
      )
    }
  }, [navigate, isTimedOut, paymentPlan, quoteId])

  useTracking('Open Banking Authentication')

  if (isLoading) return <Loader />

  return (
    <PlaidPostRedirectLoadingPage
      oauthStateId={oauthStateId}
      quoteId={quoteId}
      paymentPlan={paymentPlan}
      updateMode={updateMode}
    />
  )
}
